import { Button, Input, Skeleton, Space } from 'antd';
import { IAPIStudioInfo } from '../../../../../model/api-modules/studio';
import duiGongIcon from '../../../../../assets/svg/duigo-btn.svg';
import arrowIcon from '../../../../../assets/svg/step-arrow.svg';
import loangArrowIcon from '../../../../../assets/svg/long-arrow.svg';
// import { VersionSelect } from '../../../../admin/download/lib/select-version';
import { useEffect, useRef, useState } from 'react';
import { RechargeRecordDrawer } from './recharge-record';
import {
  IBillingAccountInfo,
  IReferenceID,
} from '../../../../../model/billing-center';
import getFormatMessage from '../../../../../locales/get-format-message';
import { GetformatMoney } from './fomat-money';
import {
  // createMidasAccount,
  createReferenceID,
  getCompanyInfo,
  getReferenceID,
} from '../../../../../api';
import { messageError } from '../../../../../components/message';
import { IAPICompanyFullInfo } from '../../../../../model/api-modules';
import { getLocaleLanguage, LanguageType } from '../../../../../lib';

interface IProps {
  readonly studioInfo: IAPIStudioInfo;
  readonly balanceList: IBillingAccountInfo | null;
  // readonly onUpdate: () => void;
}

export const RechargeComponent = (props: IProps) => {
  // const [selectedNames, setSelectedNames] = useState<string[]>([]);
  const [referenceId, setReferenceId] = useState<IReferenceID>();
  const [loading, setLoading] = useState<boolean>(false);
  const [drawer, setDrawer] = useState<boolean>(false);
  const companyInfo = useRef<IAPICompanyFullInfo>();
  const dotContent = <div className="text-dot"></div>;
  const lang = getLocaleLanguage() || LanguageType.en_US;

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    await getStudioCompany();
    await getAccount();
  };

  const getStudioCompany = async () => {
    const res = await getCompanyInfo(props.studioInfo.studio.StudioID);
    if (res) {
      companyInfo.current = res;
    }
  };

  const getAccount = async () => {
    console.log('companyInfo.current', companyInfo.current);
    if (!companyInfo.current) {
      return;
    }
    const res = await getReferenceID(props.studioInfo.studio.StudioID);
    console.log('getReferenceID-res', res);
    if (res?.reference_id) {
      setReferenceId(res);
      return;
    }
  };

  const handleAccount = async () => {
    setLoading(true);
    // const res = await createMidasAccount(props.studioInfo.studio.StudioID);
    try {
      if (companyInfo.current) {
        const createRes = await createReferenceID(
          props.studioInfo.studio.StudioID,
          companyInfo.current.Name || '',
          companyInfo.current.Contacts?.split('|')?.[2] || ''
        );
        if (createRes) {
          // 调用获取账号
          await getAccount();
        } else {
          messageError(getFormatMessage('obtain_reference_id_fail'));
        }
        console.log('createMidasAccount', createRes);
      }
    } catch (error) {
      console.error('Error creating reference ID:', error);
      messageError(getFormatMessage('create_reference_id_error'));
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDrawer = () => {
    setDrawer(false);
  };
  const handleRechargeRecord = () => {
    setDrawer(true);
  };
  const renderRecordDrawer = () => {
    if (drawer) {
      return (
        <RechargeRecordDrawer
          onClose={handleCloseDrawer}
          studioId={props.studioInfo.studio.StudioID}
        />
      );
    }
    return null;
  };

  return (
    <div className="bi-child-container">
      <div className="bi-recharge-top">
        <div className="recharge-title">
          <div>{getFormatMessage('recharge_account_information')}</div>
          <Button
            className="gc-btn gc-btn-default"
            onClick={handleRechargeRecord}
          >
            <img src={duiGongIcon} className="dui-gong-icon" />
            {getFormatMessage('recharge_record')}
          </Button>
        </div>
        <div className="recharge-top-content">
          <div className="recharge-user-info re-top-first">
            <div className="re-title"> {getFormatMessage('account')}</div>
            <div
              className="re-value"
              title={`${props.studioInfo.studio.Name} (${props.studioInfo.studio.StudioID})`}
            >
              {props.studioInfo.studio.Name}({props.studioInfo.studio.StudioID})
            </div>
          </div>
          <div className="recharge-user-info">
            <div className="re-title">{getFormatMessage('total_balance')}</div>
            <div className="re-value">
              <GetformatMoney
                className="normal-balance-detail-money child-details-money"
                money={props.balanceList?.account_balance}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bi-recharge-bottom">
        <div className="recharge-title recharge-title-last">
          {getFormatMessage('recharge_step')}
        </div>
        {/* 第一步 */}
        <div className="sync-steps recharge-steps">
          <div className="sync-step">
            <div className="step-top">
              <div className="step-dot" style={{ backgroundColor: '#FFFFFF' }}>
                <span className="step-number">1</span>
              </div>
              <div className="sync-step-title" style={{ color: '#4E5969' }}>
                {getFormatMessage('recharge_step_one_title')}
              </div>
            </div>
            <div className="step-content">
              <div className="flex-container flex-container-one">
                <img className="short-arrow" src={arrowIcon} />
                <div className="sync-description recharge-description">
                  <div className="re-steps-content">
                    {dotContent}
                    {getFormatMessage('recharge_step_one_desc_1')}{' '}
                    <span className="re-steps-yellow">
                      {getFormatMessage('recharge_step_one_desc_2')}{' '}
                    </span>
                    {getFormatMessage('recharge_step_one_desc_3')}
                  </div>
                  <div className="re-steps-content">
                    {dotContent}
                    {getFormatMessage('recharge_step_one_desc_4')}
                    <span className="re-steps-yellow">
                      {getFormatMessage('recharge_step_one_desc_5')}{' '}
                    </span>
                    {getFormatMessage('recharge_step_one_desc_6')}
                  </div>
                  <div className="re-steps-content">
                    {/* 获取工作室的企业的公司名称 */}
                    <Input
                      className="tag-select-name"
                      value={companyInfo.current?.Name}
                      disabled
                    />
                    {/* <VersionSelect
                      placeholderText="填写汇款人的真实姓名"
                      selectedVersions={selectedNames}
                      onVersionsChange={handleNamesChange}
                      className="tag-select-name"
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 第二步 */}
        <div className="sync-steps recharge-steps">
          <div className="sync-step">
            <div className="step-top">
              <div className="step-dot" style={{ backgroundColor: '#FFFFFF' }}>
                <span className="step-number">2</span>
              </div>
              <div className="sync-step-title" style={{ color: '#4E5969' }}>
                {getFormatMessage('recharge_step_two_title')}
              </div>
            </div>
            <div className="step-content">
              <div
                className={`flex-container flex-container-two ${
                  referenceId ? 'flex-container-has-id' : ''
                }`}
              >
                {loading || referenceId ? (
                  <img className="long-arrow" src={loangArrowIcon} />
                ) : (
                  <img className="short-arrow" src={arrowIcon} />
                )}
                <div className="sync-description recharge-description">
                  {loading ? (
                    <>
                      <div className="re-steps-content">
                        {dotContent}
                        {getFormatMessage('recharge_step_two_title_has')}
                      </div>
                      <div className="re-steps-content loading-content">
                        <Space className="loading-space">
                          <Skeleton.Input
                            active
                            style={{
                              width: 48,
                              minWidth: 48,
                              height: 18,
                              borderRadius: 2,
                              marginRight: 24,
                            }}
                          />
                          <Skeleton.Input
                            active
                            style={{ width: 175, height: 18, borderRadius: 2 }}
                          />
                        </Space>
                        <br />
                        <Space className="loading-space">
                          <Skeleton.Input
                            active
                            style={{
                              width: 48,
                              minWidth: 48,
                              height: 18,
                              borderRadius: 2,
                              marginRight: 24,
                            }}
                          />
                          <Skeleton.Input
                            active
                            style={{ width: 146, height: 18, borderRadius: 2 }}
                          />
                        </Space>
                        <br />
                        <Space className="loading-space">
                          <Skeleton.Input
                            active
                            style={{
                              width: 48,
                              minWidth: 48,
                              height: 18,
                              borderRadius: 2,
                              marginRight: 24,
                            }}
                          />
                          <Skeleton.Input
                            active
                            style={{ width: 200, height: 18, borderRadius: 2 }}
                          />
                        </Space>
                      </div>
                    </>
                  ) : (
                    <>
                      {referenceId ? (
                        <>
                          <div className="re-steps-content">
                            {dotContent}
                            {getFormatMessage('recharge_step_two_title_has')}
                          </div>
                          <div className="re-steps-content loading-content">
                            <div className="reference-info loading-space">
                              <span
                                className={`reference-detail-name ${
                                  lang === 'en_US'
                                    ? 'reference-detail-en-name'
                                    : ''
                                }`}
                              >
                                {getFormatMessage('recharge_account_name')}
                              </span>
                              <span className="reference-detail-value">
                                {getFormatMessage('recharge_account_company')}
                              </span>
                            </div>
                            <div className="reference-info loading-space">
                              <span
                                className={`reference-detail-name ${
                                  lang === 'en_US'
                                    ? 'reference-detail-en-name'
                                    : ''
                                }`}
                              >
                                {getFormatMessage('recharge_account_bank')}
                              </span>
                              <span className="reference-detail-value">
                                {getFormatMessage('recharge_account_bank_desc')}
                              </span>
                            </div>
                            <div className="reference-info loading-space">
                              <span
                                className={`reference-detail-name ${
                                  lang === 'en_US'
                                    ? 'reference-detail-en-name'
                                    : ''
                                }`}
                              >
                                {getFormatMessage('recharge_account')}
                              </span>
                              <span className="reference-detail-value">
                                {referenceId.receive_bank_account}
                              </span>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="re-steps-content">
                            {dotContent}
                            {getFormatMessage(
                              'recharge_step_two_desc_not_get_1'
                            )}
                          </div>
                          <div className="re-steps-content">
                            {dotContent}
                            {getFormatMessage(
                              'recharge_step_two_desc_not_get_2'
                            )}
                          </div>
                          <div className="re-steps-content">
                            <Button
                              className="gc-btn gc-btn-default"
                              onClick={handleAccount}
                            >
                              {' '}
                              {getFormatMessage('recharge_step_two_btn')}
                            </Button>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 第三步 */}
        <div className="sync-steps recharge-steps">
          <div className="sync-step">
            <div className="step-top">
              <div className="step-dot" style={{ backgroundColor: '#FFFFFF' }}>
                <span className="step-number">3</span>
              </div>
              <div className="sync-step-title" style={{ color: '#4E5969' }}>
                {getFormatMessage('recharge_step_three_title')}
              </div>
            </div>
            <div className="step-content">
              <div className="flex-container flex-container-three">
                <div className="sync-description recharge-description">
                  <div className="re-steps-content">
                    {dotContent}
                    {getFormatMessage('recharge_step_three_desc_1')}
                  </div>
                  <div className="re-steps-content">
                    {dotContent}
                    {getFormatMessage('recharge_step_three_desc_2')}
                    <span
                      className="re-steps-blue"
                      onClick={handleRechargeRecord}
                    >
                      {getFormatMessage('recharge_record_desc')}
                    </span>
                    {getFormatMessage('recharge_step_three_desc_3')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {renderRecordDrawer()}
    </div>
  );
};
